// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Group, Text, Tooltip } from '@mantine/core';
import { IconDownload, IconX } from '@tabler/icons';
import { FC, useEffect, useState } from 'react';
import { EntityType, FileS } from '../Service/FileS';
import PdfPreview from '../Molecules/Document/PdfPreviewNew';

interface Props {
  entityId?: string | null;
  eventId?: string;
  entityType?: string | null;
  filename: string;
  downloadable?: boolean;
  onDelete?: () => void;
}

const BookitupEntityPreview: FC<Props> = ({
  entityId,
  eventId,
  entityType,
  filename,
  downloadable = false,
  onDelete,
}) => {
  const [fileExists, setFileExists] = useState(true);
  const isEntityDefined = entityId && entityType;

  useEffect(() => {
    if (isEntityDefined && entityType === 'profiles') {
      FileS.isFileExists(entityType, entityId, filename).then(setFileExists);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filename, isEntityDefined]);

  return (
    <Tooltip color="red" disabled={fileExists} label="Datei nicht gefunden" position="bottom" transition="slide-down">
      <Group
        p="sm"
        pos="relative"
        sx={(theme) => ({
          borderRadius: theme.radius.sm,
          backgroundColor: fileExists ? theme.colors.gray[0] : '#FFEFEF',
        })}
      >
        {isEntityDefined && (
          <PdfPreview
            file={{ entityId, entityType, fileName: filename }}
            fileExists={fileExists}
            eventId={eventId}
            lastModified={undefined}
          />
        )}
        {!isEntityDefined && (
          <Text className="overflow-ellipsis" sx={{ width: '80%' }}>
            {filename}
          </Text>
        )}
        {downloadable && isEntityDefined && fileExists && (
          <div>
            <IconDownload
              className="hooverable-icon-blue"
              size={16}
              style={{ cursor: 'pointer' }}
              onClick={() => FileS.downloadFile(entityType as EntityType, entityId, filename)}
            />
          </div>
        )}
        {onDelete && (
          <Box pos="absolute" sx={{ right: 10 }}>
            <IconX size={16} onClick={onDelete} style={{ cursor: 'pointer' }} className="hooverable-icon" />
          </Box>
        )}
      </Group>
    </Tooltip>
  );
};

export default BookitupEntityPreview;
